/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const clientList = createSlice({
    name: 'clientList',
    initialState: initialState,
    reducers: {
        setClientList: (state, action) => {
            return action.payload;
        },
        resetClientList: () => {
            return initialState;
        },
    },
});

export const { setClientList, resetClientList } = clientList.actions;
export default clientList.reducer;
